<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("language", 2) }}</div>
        <div class="section-subTitle my-2">
          {{ $t("manage") }} {{ $tc("language", 2) }}
        </div>
      </div>
      <div>
        <b-button
          v-if="isEditable"
          variant="default"
          class="btn-blue"
          @click="() => updateOrder()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-else
          variant="default"
          class="btn-blue"
          @click="() => editOrder()"
          >{{ $t("Edit order") }}</b-button
        >
        <b-button variant="default" to="add-language" class="btn-blue">{{
          $tc("add")
        }}</b-button>
      </div>
    </div>

 

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-if="!isEditable"
          v-debounce:300="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
     
      <div class="d-flex align-items-center">
        <div class="mx-2">
           <FilterByStatusDropdown
        v-if="!isEditable"
        ref="statusDropDown"
        :onSelect="
          filterIsActive => {
            filter_is_active = filterIsActive;
            getLanguagesList();
          }
        "
      />
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Languages.length > 0"
        v-for="(item, key) in Languages"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.lang_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  @click="goToRoute('/master/edit-language', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/master/view-language', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  v-model="item.lang_is_active"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="item.lang_is_active ? 'active' : 'inactive'"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="Countries.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
              <th class="text-left" style="width:10%">
            <span class="pr-5">{{ $tc("active") }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'lang_name'"
              @click="onSortValue('lang_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('lang_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('lang_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("language", 1) }}
          </th>
      
          <th>
            <img
              v-if="this.columnName != 'iso_3'"
              @click="onSortValue('iso_3', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('iso_3', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('iso_3', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <span class="pr-5">{{ $tc("isocode3") }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'iso_2'"
              @click="onSortValue('iso_2', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('iso_2', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('iso_2', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <span class="pr-5">{{ $tc("isocode2") }}</span>
          </th>
          
        </tr>
      </thead>
      <template v-if="Languages && Languages.length > 0">
        <draggable
          :list="Languages"
          tag="tbody"
          @end="endSort($event)"
          :move="draggableElements"
        >
          <tr v-for="(item, key) in Languages" :key="key">
          <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.lang_is_active == 'Y' ? 'active' : 'inactive'"
                />

                <b-dropdown right variant="edit" class="ml-2">
                  <b-dropdown-item
                    @click="goToRoute('/master/edit-language', item)"
                  >
                    <span class="edit-pen mr-1"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="goToRoute('/master/view-language', item)"
                  >
                    <span class="icon-eye mr-1"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          <td>{{ $tc(item.lang_name, 1) }}</td>
            
            <td>{{ $tc(item.iso_3, 1) }}</td>
            <td>{{ $tc(item.iso_2, 1) }}</td>
            
          </tr>
        </draggable>
      </template>
      <tbody v-if="Languages.length == 0">
        <tr>
          <td colspan="4">
            <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- <CustomTable
      :rows="table_columns"
      :data="Languages"
      :show_status_column="true"
      status_prop_name="lang_is_active"
      :status_prop_true_value="true"
      :show_edit="true"
      :show_view="true"
      edit_path="/master/edit-language"
      edit_primary_id="lang_id"
      view_path="/master/view-language"
      view_primary_id="lang_id"
      :onSort="onSortValue"
      :use_dots="false"
      :onChangePagination="onChangePaginationHandler"
      :totalRows="rows"
      :recordsPerPage="perPage"
      :onSearch="onSearchHandler"
    > 
    </CustomTable>
    -->

    <b-pagination
      v-if="Languages.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Languages from "@/helper/formJSONMaster/Languages";
import CustomTable from "@/components/Partials/CustomTable.vue";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import draggable from "vuedraggable";

export default {
  components: {
    CustomTable,
    StatusDot,
    FilterByStatusDropdown,
    draggable
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      filter_is_active: "Y",
      isEditable: false,
      gridView: false,
      listView: true,
      Methods: Languages.Methods,
      Languages: [],
      viewingnumbers: [],
      customErrors: {
        message: ""
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "lang_name,iso_2,iso_3",

      table_columns: [
        {
          prop_name: "iso_3",
          name: this.$tc("isocode3"),
          enable_sort: true
        },
        {
          prop_name: "iso_2",
          name: this.$tc("isocode2"),
          enable_sort: true
        },
        {
          prop_name: "lang_name",
          name: this.$tc("language", 1),
          enable_sort: true
        }
      ]
    };
  },
  beforeMount() {
    this.getLanguagesList();
    this.getviewingnumber();
  },
  methods: {
    onSearch() {
      this.currentPage = 1;
      this.getLanguagesList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    draggableElements: function() {
      return this.isEditable;
    },
    endSort(event) {
      this.Languages.map((x, index) => {
        if (this.currentPage != 1) {
          x.order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.order = index + 1;
        }
      });
      console.log("this.sorted Languages", this.Languages);
      console.log("this.event", event);
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    // onChangePagination: function(event) {
    //   if (event === undefined) {
    //     this.currentPage = 1;
    //     this.getLanguagesList();
    //   } else {
    //     this.currentPage = event;
    //     this.getLanguagesList();
    //   }
    // },

    // function passed as callback to the Custom Table component
    onChangePaginationHandler: function(perPage, currentPage) {
      this.perPage = perPage;
      this.currentPage = currentPage;
      this.getLanguagesList();
    },

    onChangePagination(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getLanguagesList();
      } else {
        this.currentPage = event;
        this.getLanguagesList();
      }
    },

    // function passed as callback to custom table component
    onSearchHandler: function(searchText) {
      this.currentPage = 1;
      this.searchValue = searchText;
      this.getLanguagesList();
    },

    goToRoute: function(path, item) {
      console.log("item :", item);
      const { lang_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: lang_id
        }
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getLanguagesList();
    },
    editOrder: function() {
      this.isEditable = true;
      this.filter_is_active = "Y";
      if (this.isEditable) {
        this.perPage = this.rows;
        this.selectedvalue = "All";
        this.$refs.statusDropDown.onChangeFilterIsActive("Active");
        this.$forceUpdate();
      }
    },
    updateOrder: function() {
      this.isEditable = false;
      let payload = {
        Languages: this.Languages
      };
      console.log("In update section", this.Languages);
      MasterService.UpdateLanguageOrder(payload)
        .then(data => {
          console.log("data", data);
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLanguagesList: function() {
      this.Languages = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&orderBy=${this.orderby}&columnName=${this.columnName}&searchValue=${this.searchValue}&searchKey=${this.searchKey}&filter_is_active=${this.filter_is_active}`;
      console.log("body :", body);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Languages = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function(viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/LanguageComponents/language.vue